import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-84d4d8f6.js';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import HCaptcha from '@hcaptcha/react-hcaptcha';

require("es6-promise").polyfill();

var ENV = process.env.NODE_ENV;

var ContactForm = function ContactForm(props) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      contactFormJson = _useState2[0],
      setContactFormJson = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      accropressJWTKey = _useState4[0],
      setAccropressJWTKey = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      formLoading = _useState6[0],
      setFormLoading = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2);

  _useState8[0];
  var setIsVerified = _useState8[1];

  var _useState9 = useState(""),
      _useState10 = _slicedToArray(_useState9, 2),
      capatchaVerificationToken = _useState10[0],
      setCapatchaVerificationToken = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      formError = _useState12[0],
      setFormError = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      formSuccess = _useState14[0],
      setFormSuccess = _useState14[1];

  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit;

  var captchaRef = /*#__PURE__*/React.createRef();
  var AccroPressProdEndpoint = props.AccroPressProdEndpoint;
  var AccroPressLocalEndpoint = props.AccroPressLocalEndpoint;
  var integratorID = props.integratorID;
  var integratorAccessToken = props.integratorAccessToken;
  var AccroPressEndpoint = "";

  if (ENV === "localtest") {
    AccroPressEndpoint = AccroPressLocalEndpoint;
  } else {
    AccroPressEndpoint = AccroPressProdEndpoint;
  }

  useEffect(function () {
    var setupFormData = function setupFormData() {
      fetch(AccroPressEndpoint + "integrations/website/jwt/" + integratorID + "/" + integratorAccessToken).then(function (response) {
        return response.json();
      }).then(function (jsonResponse) {
        // TODO: Add refresh
        if (jsonResponse && jsonResponse.status === "Success" && jsonResponse.token) {
          // Set the key to use later
          setAccropressJWTKey(jsonResponse.token); // Grab the JSON data for the form

          fetch(AccroPressEndpoint + "integrations/website/contact-form/" + integratorID + "/" + integratorAccessToken).then(function (response) {
            return response.json();
          }).then(function (jsonResponseResp) {
            console.debug(jsonResponseResp);

            if (jsonResponseResp && (jsonResponseResp.status === "Success" || jsonResponseResp.status === "public")) {
              // Set the form contact data to use later
              setContactFormJson(jsonResponseResp);
            } else {
              console.error("Failed to retireve JWT from AccroPress");
            }
          });
        } else {
          console.error("Failed to retireve JWT from AccroPress");
        }
      });
    };

    setFormLoading(true);
    setupFormData();
  }, []);

  var handleChange = function handleChange(event) {
    setIsVerified(true);
  };

  var onVerifyCaptcha = function onVerifyCaptcha(token) {
    setCapatchaVerificationToken(token);
    setIsVerified(true);
  };

  var onSubmit = function onSubmit(data) {
    data["capatchaToken"] = capatchaVerificationToken;

    if (accropressJWTKey && AccroPressEndpoint && integratorID && integratorAccessToken) {
      fetch(AccroPressEndpoint + "integrations/website/contact-form-submit/" + integratorID + "/" + integratorAccessToken, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + accropressJWTKey,
          "Content-Type": "application/json"
        }
      }).then(function (res) {
        return res.json();
      }).then(function (body) {
        setFormSuccess(true);
      })["catch"](function (err) {
        console.error(err);
        setFormError("Please submit the data and capatcha correctly.");
      });
    } else {
      setFormError("The required params were not provided.");
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !formSuccess ? /*#__PURE__*/React.createElement("div", {
    className: "contact-form-inner"
  }, formLoading && contactFormJson && contactFormJson.definitionJSON && contactFormJson.definitionJSON.fields ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    id: "contact-form-form",
    className: "contact-form-form",
    onSubmit: handleSubmit(onSubmit)
  }, contactFormJson.definitionJSON.fields.length > 0 && contactFormJson.definitionJSON.fields.map(function (field, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-control",
      key: i
    }, /*#__PURE__*/React.createElement(React.Fragment, null, field.FieldType === "honeypot" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: "label-hidden",
      htmlFor: field.Identifier
    }, "Enter details"), /*#__PURE__*/React.createElement("input", {
      ref: register,
      onChange: handleChange,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "hidden",
      maxlength: field.MaxLength,
      required: ""
    })) : field.FieldType === "captcha" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: "label-hidden",
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement(HCaptcha, {
      ref: captchaRef,
      sitekey: "620d7fb4-70fa-4d71-80fe-df1fe8da5754",
      onVerify: function onVerify(token) {
        return onVerifyCaptcha(token);
      }
    })) : field.FieldType === "textarea" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement("textarea", {
      ref: register,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "text",
      maxlength: field.MaxLength,
      required: ""
    })) : field.FieldType === "dropdown" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement("select", {
      ref: register,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "text",
      maxlength: field.MaxLength,
      required: ""
    }, field.Options && field.Options.length > 0 && field.Options.map(function (option, index) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        value: option.value
      }, option.label);
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement("input", {
      ref: register,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "text",
      maxlength: field.MaxLength,
      required: ""
    }))));
  }), formError && /*#__PURE__*/React.createElement("span", null, formError), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    type: "submit"
  }, "Submit"))) : formLoading && contactFormJson && contactFormJson.definitionJSON && !contactFormJson.definitionJSON.fields && contactFormJson.definitionJSON.length > 0 ? /*#__PURE__*/React.createElement("form", {
    noValidate: true,
    id: "contact-form-form",
    className: "contact-form-form",
    onSubmit: handleSubmit(onSubmit)
  }, contactFormJson.definitionJSON.length > 0 && contactFormJson.definitionJSON.map(function (field, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-control",
      key: i
    }, /*#__PURE__*/React.createElement(React.Fragment, null, field.FieldType === "honeypot" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: "label-hidden",
      htmlFor: field.Identifier
    }, "Enter details"), /*#__PURE__*/React.createElement("input", {
      ref: register,
      onChange: handleChange,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "hidden",
      maxlength: field.MaxLength,
      required: ""
    })) : field.FieldType === "captcha" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      className: "label-hidden",
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement(HCaptcha, {
      ref: captchaRef,
      sitekey: "620d7fb4-70fa-4d71-80fe-df1fe8da5754",
      onVerify: function onVerify(token) {
        return onVerifyCaptcha(token);
      }
    })) : field.FieldType === "textarea" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement("textarea", {
      ref: register,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "text",
      maxlength: field.MaxLength,
      required: ""
    })) : field.FieldType === "dropdown" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement("select", {
      ref: register,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "text",
      maxlength: field.MaxLength,
      required: ""
    }, field.Options && field.Options.length > 0 && field.Options.map(function (option, index) {
      return /*#__PURE__*/React.createElement("option", {
        key: index,
        value: option.value
      }, option.label);
    }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: field.Identifier
    }, "Enter ", field.Label), /*#__PURE__*/React.createElement("input", {
      ref: register,
      id: field.Identifier,
      name: field.Identifier,
      placeholder: field.Label,
      pattern: field.RegEx,
      "class": "form-control-field",
      type: "text",
      maxlength: field.MaxLength,
      required: ""
    }))));
  }), formError && /*#__PURE__*/React.createElement("span", null, formError), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    type: "submit"
  }, "Submit")) : /*#__PURE__*/React.createElement("div", {
    className: "components-loading-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "components-loading-spinner"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("span", null, "Loading contact form..."))) : /*#__PURE__*/React.createElement("div", {
    className: "contact-form-success"
  }, /*#__PURE__*/React.createElement("h2", null, "Thanks for getting touch with us"), /*#__PURE__*/React.createElement("p", null, "We have recieved your query and one of our team will get back to you soon.")));
};

export default ContactForm;